import { render, staticRenderFns } from "./ExpandedManagementCard.vue?vue&type=template&id=df4b38ee"
import script from "./ExpandedManagementCard.vue?vue&type=script&lang=js"
export * from "./ExpandedManagementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports